module.exports = __webpack_public_path__ + "static/img/DITO LOGO Full Color-update.8e90cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DITO LOGO Full Color-update.png
// module id = wsDu
// module chunks = 2